class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.hideForOneDay = this.hideForOneDay.bind(this);
  }

  connectedCallback() {
    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton)
      this.closeButton.addEventListener("click", this.hideForOneDay);
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  disconnectedCallback() {
    if (this.closeButton)
      this.closeButton.removeEventListener("click", this.hideForOneDay);
  }
}

customElements.define("announcement-bar", AnnouncementBar);
